export default (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/arrayToObject.js
// module id = 513
// module chunks = 31 32 33 34 35